import { create } from 'zustand';
import getSafely from '@/utils/getSafely';
import type { UserInfo } from '@/services/login/types';

interface UserState {
  userData: UserInfo | null
}

interface UserActions {
  updateUser: (userInfo: UserInfo) => void
  resetUser: () => void
}

type UserStore = UserState & UserActions

const initUserData = getSafely(() => {
  const userData = localStorage.getItem('userData')
  return userData ? JSON.parse(decodeURIComponent(userData)) : null
})


export const userStore = create<UserStore>((set) => ({
  userData: initUserData,
  updateUser: (userInfo: UserInfo) => set({ userData: userInfo }),
  resetUser: () => set({ userData: null })
}))

export const useUserStore = userStore
